/**
 * Created by Ivan on 07.07.2026
 */

const StickersCollectionIcon = function (collection) {
    return Prefab.instantiate(bundles.stickers_book_window.jsons.stickers_collection_icon_prefab_json, { collection });
};
